import { Component } from "vue-property-decorator"

import actionAlertBase from "./actionAlert.client.base"

@Component
export default class ActionAlertWeb extends actionAlertBase {}
